"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markdownToHtml = exports.htmlToMarkdown = exports.fromDisplay = exports.toDisplay = void 0;

var _turndown = _interopRequireDefault(require("turndown"));

var _turndownPluginGfm = require("turndown-plugin-gfm");

var _showdown = _interopRequireDefault(require("showdown"));

var _string = require("./string");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var turndownService = new _turndown.default({
  headingStyle: 'atx'
});
turndownService.use(_turndownPluginGfm.gfm);
turndownService.addRule('strikethrough', {
  filter: ['del', 's', 'strike'],
  replacement: function replacement(content) {
    return "~".concat(content, "~");
  }
});
turndownService.addRule('underline', {
  filter: ['u'],
  replacement: function replacement(content) {
    return "<u>".concat(content, "</u>");
  }
});
turndownService.addRule('emphasis', {
  filter: ['em'],
  replacement: function replacement(content) {
    return "*".concat(content, "*");
  }
});
var markdownToHtmlConverter = new _showdown.default.Converter();
markdownToHtmlConverter.setOption('underline', true);

var toDisplay = function toDisplay(content) {
  return content.replace(/&/g, '&amp;').replace(/</g, '&lt;');
};

exports.toDisplay = toDisplay;

var fromDisplay = function fromDisplay(content) {
  return content.replace(/&lt;/g, '<').replace(/&amp;/g, '&');
};

exports.fromDisplay = fromDisplay;

var htmlToMarkdown = function htmlToMarkdown(_ref) {
  var html = _ref.html,
      _ref$outputFilters = _ref.outputFilters,
      outputFilters = _ref$outputFilters === void 0 ? [] : _ref$outputFilters;
  var markdown = turndownService.turndown(html);
  markdown = (0, _string.filter)({
    string: markdown,
    filters: outputFilters
  });

  if (markdown === '&#8203;') {
    markdown = '';
  }

  return markdown;
};

exports.htmlToMarkdown = htmlToMarkdown;

var markdownToHtml = function markdownToHtml(_ref2) {
  var markdown = _ref2.markdown,
      _ref2$inputFilters = _ref2.inputFilters,
      inputFilters = _ref2$inputFilters === void 0 ? [] : _ref2$inputFilters;

  var _markdown = markdown.slice(0);

  _markdown = (0, _string.filter)({
    string: _markdown,
    filters: inputFilters
  });
  var html = markdownToHtmlConverter.makeHtml(_markdown);

  if (!html || html === '') {
    html = '<p>&#8203;</p>';
  }

  return html;
};

exports.markdownToHtml = markdownToHtml;